import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';
import PageEditor from './PageEditor.vue';
import SiteSettings from './SiteSettings.vue';

const meta = { permissions: ['administrator'] };

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/landing-pages'),
      component: SettingsWrapper,
      children: [
        { path: '', name: 'settings_landing_pages', component: Index, meta },
        {
          path: 'config',
          name: 'settings_landing_pages_site',
          component: SiteSettings,
          meta,
        },
        {
          path: 'new',
          name: 'settings_landing_pages_new',
          component: PageEditor,
          meta,
        },
        {
          path: ':pageId',
          name: 'settings_landing_pages_edit',
          component: PageEditor,
          meta,
        },
      ],
    },
  ],
};
